export default __webpack_public_path__ + "static/media/3VA.d3a05224.jpg";